import { useParams } from 'next/navigation';

import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useBlogTracking() {
  const params = useParams<{ slug: string }>();
  const [, user] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({ userId: user?.id });

  function sendBlogArticleViewEvent() {
    sendActivityTrackerEvent(ActivityTrackerEventType.BLOG_ARTICLE_VIEW, {
      articleSlug: params.slug,
      schemaVersion: '1.0',
    });
  }

  function sendBlogInteractionActionEvent({
    articleSlug,
    itemName,
    interactionType,
  }: {
    articleSlug?: string;
    itemName?: string;
    interactionType: string;
  }) {
    sendActivityTrackerEvent(ActivityTrackerEventType.BLOG_INTERACTION_ACTION, {
      articleSlug,
      itemName,
      interactionType,
      schemaVersion: '2.0',
    });
  }

  return {
    sendBlogArticleViewEvent,
    sendBlogInteractionActionEvent,
  };
}
